import React, { useEffect } from "react";
import { animateScroll as scroll } from "react-scroll";

const TheScentOfMusic = () => {
  const pdfUrl =
    "https://firebasestorage.googleapis.com/v0/b/noemigyori.appspot.com/o/Files%2Fthe_scent_of_music.pdf?alt=media&token=d74d03ba-4861-4f33-9419-58d1c6c7bbe5";

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  useEffect(() => {
    (() => {
      scroll.scrollToTop();
    })();
  }, []);

  // On mobile, use object tag which opens native viewer within the page
  if (isMobile) {
    return (
      <div
        style={{
          width: "100%",
          height: "100vh",
          margin: 0,
          padding: 0,
          overflow: "hidden",
          position: "relative",
          maxWidth: "100%",
        }}
      >
        <object
          data={pdfUrl}
          type="application/pdf"
          style={{
            width: "100%",
            height: "100%",
            border: "none",
          }}
        >
          <iframe
            src={pdfUrl}
            title="The Scent of Music"
            style={{
              width: "100%",
              height: "100%",
              border: "none",
            }}
          />
        </object>
      </div>
    );
  }

  // Show iframe on desktop
  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        margin: 0,
        padding: 0,
        overflow: "auto",
        position: "relative",
        maxWidth: "100%",
      }}
    >
      <iframe
        src={`${pdfUrl}#toolbar=0&navpanes=0&scrollbar=1`}
        title="The Scent of Music"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
          margin: 0,
          padding: 0,
          minHeight: "100vh",
          maxWidth: "100%",
        }}
      />
    </div>
  );
};

export default TheScentOfMusic;
